import { render } from "./AccountEmailPage.vue?vue&type=template&id=b743e284&ts=true"
import script from "./AccountEmailPage.vue?vue&type=script&lang=ts"
export * from "./AccountEmailPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__